// extracted by mini-css-extract-plugin
export default {"dialog-paper-root":"dialog-paper-root--ywVc2","popover-paper-root":"popover-paper-root--iBoCp"};